import { render, staticRenderFns } from "./LazyComponent.vue?vue&type=template&id=5b7b22c7&scoped=true"
import script from "./LazyComponent.vue?vue&type=script&lang=ts"
export * from "./LazyComponent.vue?vue&type=script&lang=ts"
import style0 from "./LazyComponent.vue?vue&type=style&index=0&id=5b7b22c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b22c7",
  null
  
)

export default component.exports